import { connect } from 'react-redux';
export const makeConnectState = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return (mapStateToProps) => {
        return (component) => connect(mapStateToProps)(
        // `any` was added as part of updating to react-redux 8.x.x, where the types of `connect` changed,
        // where we had trouble with getting `connect` to accept the type of `component`.
        // It's worth noting that the typing when using `makeConnectState` is still correct externally.
        component);
    };
};
